import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=7bf84c9c"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"
import style0 from "./MenuManagement.vue?vue&type=style&index=0&id=7bf84c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports